module.exports = __webpack_public_path__ + "static/media/noInvoices.3cd7bcb3.png";